import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["playButton", "playingIndicator", "audio", "question", "startTime"]

  connect() {
    // Only set up if we have all the targets (i.e., not in feedback state)
    if (!this.hasPlayButtonTarget || !this.hasPlayingIndicatorTarget || !this.hasQuestionTarget || !this.hasAudioTarget) {
      return
    }

    // Set up event listeners
    this.boundHandleAudioEnd = this.handleAudioEnd.bind(this)
    this.boundHandleAudioPlay = this.handleAudioPlay.bind(this)
    this.boundHandleAudioError = this.handleAudioError.bind(this)
    
    this.audioTarget.addEventListener("ended", this.boundHandleAudioEnd)
    this.audioTarget.addEventListener("play", this.boundHandleAudioPlay)
    this.audioTarget.addEventListener("error", this.boundHandleAudioError)
    
    // Ensure initial state: only play button visible
    this.playButtonTarget.style.display = "block"
    this.playingIndicatorTarget.style.display = "none"
    this.questionTarget.style.display = "none"
  }

  disconnect() {
    if (this.hasAudioTarget) {
      this.audioTarget.removeEventListener("ended", this.boundHandleAudioEnd)
      this.audioTarget.removeEventListener("play", this.boundHandleAudioPlay)
      this.audioTarget.removeEventListener("error", this.boundHandleAudioError)
    }
  }

  play(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    // Validate targets exist
    if (!this.hasPlayButtonTarget || !this.hasPlayingIndicatorTarget || !this.hasAudioTarget) {
      return
    }
    
    // Hide play button, show playing indicator
    this.playButtonTarget.style.display = "none"
    this.playingIndicatorTarget.style.display = "block"
    
    // Start playing audio
    const playPromise = this.audioTarget.play()
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // User interaction required or other error
        // Reset UI on error
        this.playButtonTarget.style.display = "block"
        this.playingIndicatorTarget.style.display = "none"
      })
    }
  }

  handleAudioPlay() {
    // Set start time when audio actually starts playing
    if (this.hasStartTimeTarget) {
      const startTimeField = this.startTimeTarget
      if (!startTimeField.value || startTimeField.value === "") {
        startTimeField.value = new Date().toISOString()
      }
    }
  }

  handleAudioError(event) {
    // Reset UI on error
    if (this.hasPlayButtonTarget) {
      this.playButtonTarget.style.display = "block"
    }
    if (this.hasPlayingIndicatorTarget) {
      this.playingIndicatorTarget.style.display = "none"
    }
  }

  handleAudioEnd() {
    if (!this.hasPlayingIndicatorTarget || !this.hasQuestionTarget) {
      return
    }
    
    // Hide playing indicator
    this.playingIndicatorTarget.style.display = "none"
    
    // Wait 300ms, then show question with fade-in
    setTimeout(() => {
      this.questionTarget.style.display = "block"
      // Trigger fade-in transition
      requestAnimationFrame(() => {
        this.questionTarget.classList.remove("opacity-0")
        this.questionTarget.classList.add("opacity-100")
      })
      
      // Focus answer field after transition
      setTimeout(() => {
        const answerField = this.questionTarget.querySelector('input[type="text"]')
        if (answerField) {
          answerField.focus()
        }
      }, 600)
    }, 300)
  }
}
